import React from 'react';
import ReactDOM from 'react-dom/client';
import '@telegram-apps/telegram-ui/dist/styles.css';
import { AppRoot } from '@telegram-apps/telegram-ui';
import { BrowserRouter } from "react-router";
import { init, viewport } from '@telegram-apps/sdk-react';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const initialize = async () => {
  init();

  viewport.expand();
}

initialize();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
